<template>
    <div>
        <b-form-group
            label="Question"
            label-for="question"
        >
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('question', $event)"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
            label="Options"
            label-for="options"
            class="mb-2"
        >
            <div
                v-for="(answer, index) in editable_content.possible_answers"
                :key="index"
                class="mb-1"
            >
                <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                        <b-input-group>
                            <b-input-group-prepend class="text-capitalize" is-text>
                                <div class="answer-option">{{answer.option}}</div>
                            </b-input-group-prepend>

                            <b-input-group-prepend is-text>
                                <b-form-checkbox
                                    class="mr-n2"
                                    :id="'checkbox' + answer.option"
                                    :disabled="!answer.value"
                                    :checked="isAnswer(answer.option)"
                                    :state="validating && (!editable_content.answers || editable_content.answers && !editable_content.answers.length) ? false : null"
                                    @change="toggleAnswer(answer.option)"
                                >
                                </b-form-checkbox>
                            </b-input-group-prepend>

                            <b-form-textarea
                                v-model="answer.value"
                                :state="validating && (!answer.value) ? false : null"
                            />
                        </b-input-group>

                        <!-- <b-form-invalid-feedback :state="validating && ((answer.option == 'a' || answer.option == 'b') && !answer.value) ? false : null">
                            Option <span class="text-capitalize">{{answer.option}}</span> is required
                        </b-form-invalid-feedback> -->

                        <b-form-invalid-feedback :state="validating && (!answer.value) ? false : null">
                            Option text is required
                        </b-form-invalid-feedback>
                    </div>
                    <!-- <div v-if="editable_content.possible_answers && editable_content.possible_answers.length && (index > 1)" class="ml-2">
                        <b-btn variant="link" class="text-danger" @click.prevent="removeOption(index)">
                            <font-awesome-icon :icon="['far', 'times']" />
                        </b-btn>
                    </div> -->
                </div>
            </div>

            <b-form-invalid-feedback :state="validating && (!editable_content.answers || editable_content.answers && !editable_content.answers.length) ? false : null">
                At least 1 answer is required
            </b-form-invalid-feedback>

        </b-form-group>

        <!-- <div class="mb-3">
            <b-btn
                size="sm"
                variant="outline-primary"
                @click.prevent="addOption"
            >
                <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Option
            </b-btn>
        </div> -->
    </div>
</template>

<style lang="scss" scoped>
.answer-option {
    min-width: 15px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        editable_content: {
            possible_answers: [
                {
                    option: 'a'
                },
                {
                    option: 'b'
                },
                {
                    option: 'c'
                },
                {
                    option: 'd'
                }
            ],
            answers: []
        }
    }),
    props: [
        'question',
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        question: {
            handler (question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        addOption () {
            if (!this.editable_content.possible_answers) {
                this.$set(this.editable_content, 'possible_answers', [])
            }

            let nextAvailableLetter = null

            if (
                this.editable_content.possible_answers &&
                this.editable_content.possible_answers.length
            ) {
                _.forEach(this.editable_content.possible_answers, possible_answer => {
                    nextAvailableLetter = String.fromCharCode(possible_answer.option.charCodeAt(0) + 1)
                })
            } else {
                nextAvailableLetter = 'a'
            }

            this.editable_content.possible_answers.push({
                option: nextAvailableLetter
            })
        },
        removeOption (index) {
            this.editable_content.possible_answers.splice(index, 1)
        },
        isAnswer (option) {
            let is_answer = false

            if (_.includes(this.editable_content.answers, option)) {
                is_answer = true
            }

            return is_answer
        },
        toggleAnswer (option) {
            if (_.includes(this.editable_content.answers, option)) {
                const index = this.editable_content.answers.findIndex(answer => answer == option)
                this.editable_content.answers.splice(index, 1)
            } else {
                this.editable_content.answers.push(option)
            }
        },
        setContent (field, value) {
            this.$set(this.editable_content, field, value)
        }
    }
}
</script>
